export default function isObjectId(target: string): boolean {
  return /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i.test(target);
}
